import React from 'react';

interface DistributorHistoryStatsProps {
  distributorsData: any[];
}

const DistributorHistoryStats: React.FC<DistributorHistoryStatsProps> = ({ distributorsData }) => {
  return (
    <section style={{
      marginBottom: '2rem'
    }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1.5rem',
        marginBottom: '2rem'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%)',
          backdropFilter: 'blur(25px)',
          borderRadius: '16px',
          padding: '1.5rem',
          border: '1px solid rgba(16, 185, 129, 0.1)',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '2rem',
            fontWeight: '900',
            color: '#10b981',
            marginBottom: '0.5rem'
          }}>
            {distributorsData.length}
          </div>
          <div style={{
            fontSize: '0.9rem',
            color: '#6b7280',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Total Distributors
          </div>
        </div>

        <div style={{
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%)',
          backdropFilter: 'blur(25px)',
          borderRadius: '16px',
          padding: '1.5rem',
          border: '1px solid rgba(59, 130, 246, 0.1)',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '2rem',
            fontWeight: '900',
            color: '#3b82f6',
            marginBottom: '0.5rem'
          }}>
            ₹{(distributorsData.reduce((sum, dist) => sum + (dist?.settled_amount || 0) + (dist?.unsettled_amount || 0), 0)).toFixed(2)}
          </div>
          <div style={{
            fontSize: '0.9rem',
            color: '#6b7280',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Total Amount
          </div>
        </div>

        <div style={{
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%)',
          backdropFilter: 'blur(25px)',
          borderRadius: '16px',
          padding: '1.5rem',
          border: '1px solid rgba(239, 68, 68, 0.1)',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '2rem',
            fontWeight: '900',
            color: '#ef4444',
            marginBottom: '0.5rem'
          }}>
            ₹{distributorsData.reduce((sum, dist) => sum + (dist?.unsettled_amount || 0), 0).toFixed(2)}
          </div>
          <div style={{
            fontSize: '0.9rem',
            color: '#6b7280',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Pending Amount
          </div>
        </div>

        <div style={{
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%)',
          backdropFilter: 'blur(25px)',
          borderRadius: '16px',
          padding: '1.5rem',
          border: '1px solid rgba(245, 158, 11, 0.1)',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '2rem',
            fontWeight: '900',
            color: '#f59e0b',
            marginBottom: '0.5rem'
          }}>
            {distributorsData.reduce((sum, dist) => sum + (dist?.totalMedicines || 0), 0)}
          </div>
          <div style={{
            fontSize: '0.9rem',
            color: '#6b7280',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            Total Medicines
          </div>
        </div>
      </div>
    </section>
  );
};

export default DistributorHistoryStats;

